export default __webpack_public_path__ + "static/media/down.f1e30042.svg";